<template>
  <div class="cmp-royalty-recoupable-recoupable_list">
    <div>
      <NTable
        id="royalty-recoupable-recoupable_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onScrollNext"
        :height="28 * list.length + 56 + ''"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('date')" @click="onClickRecoupable(item)">
              <div class="ut-link ut-text-accent5" style="font-weight: bold">
                {{ item["date"] }}
              </div>
            </td>
            <td v-bind="tdcon('cost_group_name')">
              <span>{{ item["cost_group_name"] }}</span>
            </td>
            <td v-bind="tdcon('description')">
              <span>{{ item["description"] }}</span>
            </td>
            <td v-bind="tdcon('ignore')">
              <!-- <div v-if="item['balance_entries']==0" class="ut-rowcen">
                    <div class="dt-checkbox v2 s1">
                        <input
                                type="checkbox"
                                :name="'hold_flag'"
                                :id="'hold_flag'"
                                :checked="item['hold_flag']"
                                @click="(e) => onCheckBoxChange(e, item)"
                        />
                    <div class="checkmark"></div>
                    </div>
                </div> -->
              <!-- {{item['hold_flag']}} -->
              <div class="dt-icon-container">
                <template v-if="!item['status'].startsWith('Accounted:')">
                  <img
                    v-if="item['hold_flag'] == 1"
                    @click.stop="(e) => onCheckBoxChange(e, item)"
                    :src="'static/icons/omit-accent.svg'"
                    class="dt-icon v5 s1"
                  />

                  <img
                    v-else
                    @click.stop="(e) => onCheckBoxChange(e, item)"
                    :src="'static/icons/omit.svg'"
                    class="dt-icon v5 s1"
                  />
                </template>
              </div>
            </td>
            <td v-bind="tdcon('income')">
              <span
                v-if="
                  (item['external_table'] == 'product_income' ||
                    item['external_table'] == 'release_income') &&
                  parseFloat(item['amount'])
                "
                >{{
                  parseFloat(item["amount"]).toFixed(2) +
                  " " +
                  item["system_currency"]
                }}</span
              >
            </td>
            <td v-bind="tdcon('cost')">
              <span
                v-if="
                  (item['external_table'] == 'release' ||
                    item['external_table'] == 'product') &&
                  parseFloat(item['amount'])
                "
                >{{
                  parseFloat(item["amount"]).toFixed(2) +
                  " " +
                  item["system_currency"]
                }}</span
              >
            </td>
            <td v-bind="tdcon('status1')">
              <span
                style="font-weight: bold"
                @click.stop="(e) => onRecoupStatusClick(item)"
                class="txtov"
              >
                {{ item["status"] }}
              </span>
            </td>
          </tr>
        </template>
        <template v-slot:tfoot="{ thcon }">
          <tr class="table-footer">
            <td
              v-bind="thcon('date')"
              style="overflow: visible; position: relative"
            >
              <span
                style="
                  width: max-content;
                  position: absolute;
                  color: #828282;
                "
                >{{ listItem.footerTitle }}</span
              >
            </td>
            <td v-bind="thcon('cost_group_name')"></td>
            <td v-bind="thcon('description')"></td>
            <td v-bind="thcon('ignore')"></td>
            <td style="text-align: right" v-bind="thcon('income')">
              <div class="ut-flex ut-jend">
                <span
                  style="
                    background-color: #64c89680;
                    padding: 3px 8px;
                    line-height: 16px;
                    border-radius: 15px;
                  "
                >
                  {{ totalIncome }}
                </span>
              </div>
            </td>
            <td style="text-align: right" v-bind="thcon('cost')">
              <div class="ut-flex ut-jend">
                <span
                  style="
                    background-color: #ff6e6e80;
                    padding: 3px 8px;
                    line-height: 16px;
                    border-radius: 15px;
                  "
                >
                  {{ totalCost }}
                </span>
              </div>
            </td>
            <td v-bind="thcon('status1')"></td>
          </tr>
        </template>
      </NTable>
    </div>
  </div>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { openModalRoute2 } from "../../../../dt-plugins/modal/modal.mixin";

import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";

import { subscribeSubject } from "../../../../utility";

import { createTV, tv } from "../../../../models/text-value.model";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { baseUrl } from "../../../b2b/services/http-client";
import { sendMail } from "../../../../utility";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { recoupableActions } from "../../store/recoupable/actions";
import { recoupableGetters } from "../../store/recoupable/getters";
import { recoupableService } from "../../services/recoupable-service";

export default {
  props: {
    loadingFlag: {
      type: Boolean,
      default: false,
    },
    listItem: {
      type: Object,
    },
  },
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

    //AdvanceSearch,
  },
  mounted: function () {},
  data: function () {
    return {
      defaultConfig: defaultConfig,
      searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search
    };
  },
  mixins: [
    // createModalMixin("confirmRoyalty"),
    // createModalMixin("batchStatement"),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, recoupableGetters),

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        footer: true,
      });
    },
    list: function () {
      return this.listItem?.items;
    },

    totalIncome: function () {
      return (
        this.listItem?.items
          ?.filter(
            (e) =>
              e.external_table == "product_income" ||
              e.external_table == "release_income"
          )
          .reduce((accum, cur) => {
            // console.log("cur", cur.amount);
            // console.log('accum', accum);
            if (parseFloat(cur.amount)) {
              accum = parseFloat(accum) + parseFloat(cur.amount);
            }

            return `${parseFloat(accum).toFixed(2)} ${
              this.$store.getters.account.client.default_currency
            }`;
          }, 0) || `0.00 ${this.$store.getters.account.client.default_currency}`
      );
    },
    totalCost: function () {
      return (
        this.listItem?.items
          ?.filter(
            (e) =>
              e.external_table == "product" || e.external_table == "release"
          )
          .reduce((accum, cur) => {
            // console.log("cur", cur.amount);
            // console.log('accum', accum);
            if (parseFloat(cur.amount)) {
              accum = parseFloat(accum) + parseFloat(cur.amount);
            }

            return `${parseFloat(accum).toFixed(2)} ${
              this.$store.getters.account.client.default_currency
            }`;
          }, 0) || `0.00 ${this.$store.getters.account.client.default_currency}`
      );
    },
    contactHeaders: function () {
      return [
        createTableHeader("date", { text: "Cost Date", mw: 85 }),
        createTableHeader("cost_group_name", { f:1.2,text: "Group" }),
        createTableHeader("description", {f:1.5}),
        createTableHeader("ignore", { ta: "center", mw: 80 }),
        createTableHeader("income", { ta: "right" ,mw:150}),
        createTableHeader("cost", { ta: "right" ,mw:150}),
        createTableHeader("status1", { text: this.$t("status") }),
      ];
    },
    advancedSearchData: function () {
      return [];
    },
  },
  methods: {
    ...mapActionObject(storeNS,recoupableActions),
    onScrollNext: function () {},

    onCheckBoxChange: function (e, item) {
      console.log(e.target.src);

      const imgSrc = e.target.src;

      const value = imgSrc.includes("accent") ? "" : 1;

      const payload = {
        kVal: item.cost_split_id,
        name: "status",
        value: value,
        item: item,
      };

      this.$emit("changed", payload);
    },

    onClickRecoupable: function (item) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "edit_recoupable",
          cost_split_id: item.cost_split_id,
        },
      });
    },

    recoupStatus: function (item) {
      const status = item["status"] || "";
      if (status.startsWith("Accounted:")) {
        return status.slice(11);
      } else {
        return status;
      }
    },
    onRecoupStatusClick: async function (item) {
      const { cost_split_id, status } = item;

      switch (status) {
        case "Open Advance": {
          openModalRoute2(this, "costOpenAdvance", {
            cost_split_id,
          });

          break;
        }
        case "Not Recoupable": {
          openModalRoute2(this, "costRecoupables", {
            cost_split_id,
          });

          break;
        }
        case "Do not Recoup": {
          break;
        }
        case "Account Recoupables": {
          console.log("::::::::::",cost_split_id,status)
          this[ActionTypes.RecoupableList.UPDATE.SINGLE]({name:status,kVal:cost_split_id,value:'',item:{}});
          break;
        }
        default: {
          // If Recoup Status is Accounted
          if (status.startsWith("Accounted:")) {
            openModalRoute2(this, "costRecoupables", {
              cost_split_id,
            });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-recoupable-recoupable_list {
  &:not(:first-child) {
    //  margin-top: 20px;
  }
  thead {
    tr {
      /// border-top: 1px solid var(--bc-accent);
      color: var(--bc-accent);
    }
  }
  .table-footer {
    //color: var( --sprt-85);
    //border-bottom: 1px solid rgba(0,0,0,0.12);
  }
}
</style>
